module.exports = __webpack_public_path__ + "static/lesna-40d5611571fcdcee3deaebdc3d26e136.png";